// extracted by mini-css-extract-plugin
module.exports = {"LightScroll":"lend_LightScroll__2uwtS","DarkScroll":"lend_DarkScroll__mKJKi","scroll":"lend_scroll__2jLEL"};